module.exports = "/assets/fadd20bfe9235eca3d43eb55880f531c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RJ.png
// module id = 2911
// module chunks = 0